<div class="select">
	<ga-candidate-select
		*ngIf="candidates.length > 0"
		[allCandidates]="candidates"
		[placeholder]="'FORM.PLACEHOLDERS.ADD_REMOVE_CANDIDATE' | translate"
		(selectedChange)="onMembersSelected($event)"
	>
	</ga-candidate-select>
</div>

<div *ngIf="rating.length === 0" class="no-data">
	<nb-icon icon="info-outline" class="no-data-icon"></nb-icon>
	<span class="no-data-text">{{
		'CANDIDATES_PAGE.STATISTIC.NO_DATA' | translate
	}}</span>
	<span class="no-data-text" *ngIf="candidates.length > 0">
		{{ 'CANDIDATES_PAGE.STATISTIC.SELECT_CANDIDATE' | translate }}
	</span>
</div>
<chart
	*ngIf="rating.length > 0"
	style="height: 400px; width: 100%;"
	type="bar"
	[data]="data"
	[options]="options"
></chart>
